// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeViewComplianceSection-LockedOutIcon_cls1__eap++","cls2":"PayeeViewComplianceSection-LockedOutIcon_cls2__euYz8 PayeeViewComplianceSection-LockedOutIcon_cls1__eap++"};